import { CheckIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { FilterItem } from './filter';

export const StatusFilters: FilterItem[] = [
  {
    id: '1',
    name: 'درست',
    icon: <CheckIcon color='green' width='20px' />
  },
  {
    id: '0',
    name: 'نزده',
    icon: <ExclamationTriangleIcon color='amber' width='20px' />
  },
  {
    id: '-1',
    name: 'غلط',
    icon: <XMarkIcon color='red' width='20px' />
  }
];
